const createArrayValidator = (singleRowValidator, rowsValidator) => listOfRows => {
  if (!listOfRows) {
    return []
  }
  let responseErrors = listOfRows.reduce((errors, row, index) => {
    const error = singleRowValidator(row)
    if (error) {
      errors[index] = error
    }
    return errors
  }, [])
  if (responseErrors.length) {
    return responseErrors
  }
  responseErrors = listOfRows.reduce((errors, row, index) => {
    const error = rowsValidator(listOfRows, row, index)
    if (error) {
      errors[index] = error
    }
    return errors
  }, [])
  if (responseErrors.length) {
    return responseErrors
  }
}

export default createArrayValidator
